module.exports = __webpack_public_path__ + "static/media/base_impact_waste.e9af3141.png";